import React from 'react';

const MainContent = ({ title }) => {
    const devTopics = [
        { id: 1, title: "Version Control", description: "Master Git and GitHub for efficient collaboration." },
        { id: 2, title: "Code Optimization", description: "Learn best practices for writing clean and efficient code." },
        { id: 3, title: "Debugging Techniques", description: "Explore tools and methods to debug like a pro." },
        { id: 4, title: "DevOps Essentials", description: "Understand CI/CD pipelines and infrastructure automation." },
    ];

    return (
        <section className="dev-main-content">
            <h1>{title}</h1>  
            <h1 className="dev-title">Developer's Knowledge Hub</h1>
            <p className="dev-intro">
                Welcome to the central hub for all things development. Explore topics that every developer should master.
            </p>
            <ul className="dev-topic-list">
                {devTopics.map((topic) => (
                    <li key={topic.id} className="dev-topic-item">
                        <h2 className="dev-topic-title">{topic.title}</h2>
                        <p className="dev-topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default MainContent;